import { useState, useEffect } from 'react';
import { colors, spacing } from '../theme';
import Icon from './Icon';
import Input from './Input';

const styles = {
  container: {
    position: 'relative',
    marginBottom: spacing.md,
  },
  searchIcon: {
    position: 'absolute',
    left: spacing.md,
    top: '50%',
    transform: 'translateY(-50%)',
    color: colors.midGray,
    pointerEvents: 'none',
    zIndex: 1,
  },
  input: {
    paddingLeft: '2.5rem',
  },
  clearButton: {
    position: 'absolute',
    right: spacing.sm,
    top: '50%',
    transform: 'translateY(-50%)',
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: spacing.xs,
    color: colors.midGray,
    display: 'flex',
    alignItems: 'center',
    zIndex: 1,
  },
};

function useDebounce(value, delay) {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
}

function SearchBar({
  value,
  onChange,
  placeholder = 'Search...',
  debounceDelay = 300,
  onClear = null,
  style = {},
  ...props
}) {
  const [localValue, setLocalValue] = useState(value || '');
  const debouncedValue = useDebounce(localValue, debounceDelay);

  useEffect(() => {
    if (debouncedValue !== value) {
      onChange(debouncedValue);
    }
  }, [debouncedValue, onChange, value]);

  useEffect(() => {
    setLocalValue(value || '');
  }, [value]);

  const handleChange = (e) => {
    setLocalValue(e.target.value);
  };

  const handleClear = () => {
    setLocalValue('');
    onChange('');
    if (onClear) {
      onClear();
    }
  };

  return (
    <div style={{ ...styles.container, ...style }} {...props}>
      <Icon name="search" type="action" size={20} style={styles.searchIcon} />
      <Input
        type="text"
        value={localValue}
        onChange={handleChange}
        placeholder={placeholder}
        style={styles.input}
        aria-label="Search"
        maxLength={200}
      />
      {localValue && (
        <button
          onClick={handleClear}
          style={styles.clearButton}
          aria-label="Clear search"
          onMouseEnter={(e) => (e.target.style.color = colors.darkGray)}
          onMouseLeave={(e) => (e.target.style.color = colors.midGray)}
        >
          <Icon name="close" type="status" size={18} />
        </button>
      )}
    </div>
  );
}

export default SearchBar;

